import Mention from '@tiptap/extension-mention';

import suggestion from './suggestion';

const SnippetExtension = ({ fetchSnippets }) =>
	Mention.extend({
		name: 'snippet',
		addOptions() {
			return {
				HTMLAttributes: {
					class: 'snippet'
				},
				suggestion: {
					...suggestion,
					char: '#',
					allowSpaces: true,
					items: ({ query }) => fetchSnippets(query)
				}
			};
		}
	});

export default SnippetExtension;
